import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { AssignmentsWorkTypeMap } from 'src/interfaces/assignment.types';
import authService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { useGetStudentAssignmentsQuery } from 'src/store/api/assignment';
import {
  useActiveMSAssignmentsSubject,
  useCurrentAppViewSelector,
} from 'src/store/features';
import { getRelevantWorkTypeForQuery } from 'src/utils/assignments.utils';

export const useMSStudentAssignmentsByWorkType = (
  workType: AssignmentsWorkTypeMap,
) => {
  const activeMSAssignmentsSubject = useActiveMSAssignmentsSubject();
  const isMiddleSchoolView = useIsMiddleSchoolView();
  const currentAppView = useCurrentAppViewSelector();

  const isTeacher = authService.isTeacher();
  const shouldSkipQuery =
    isTeacher || currentAppView === null || !isMiddleSchoolView;

  // pass correct workType instead of skipping query for Apps section - for correct realtime logic work
  const relevantWorkType = getRelevantWorkTypeForQuery(workType);

  const studentAssignmentsQueryParams = {
    workType: relevantWorkType,
    // APPS enum value is 'TODO', so this check covers both TODO and APPS
    // Since AssignmentsWorkTypeMap only has TODO and PAST_WORK, this is always true
    includeSingleSessionCodes: true,
  };

  const queryResult = useGetStudentAssignmentsQuery(
    {
      domain: activeMSAssignmentsSubject,
      ...studentAssignmentsQueryParams,
    },
    {
      skip: shouldSkipQuery,
    },
  );

  if (queryResult.error) {
    loggerService.logError(
      'Something went wrong during MS student assignments query',
      queryResult.error,
    );
  }

  return queryResult;
};
